import { Form, Input } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { LoginSignupFormType } from "../../../../Utils/Constants/loginSignupFormTypes";
import { vuaIdSuffix } from "../../../../Utils/Constants/vuaIdSuffix";
import PinInputComponent from "../../../Common/Components/PinInput";
import "./index.css";
interface IUserProp {
  vuaIdValidator: (_: any, value: string) => void;
}

const UserInformation: React.FC<IUserProp> = ({ vuaIdValidator }) => {
  const onNameChange = (e: any) => {
    e.target.value = e.target.value.replace(/[^A-Za-z]+/g, "");
  };
  const onVUANameChange = (e: any) => {
    e.target.value = e.target.value.replace(/[^A-Za-z0-9]+/g, "");
  };
  const { t } = useTranslation();

  return (
    <>
      <div className="flexCommonCss width">
        <Form.Item
          rules={[
            {
              required: true,
              message: "* Required field",
            },
          ]}
          name={LoginSignupFormType.firstName}
          className="inputCss formItemMarginBotton"
        >
          <Input
            id="firstName"
            type="text"
            onInput={onNameChange}
            placeholder={t("Firstname")}
            allowClear={true}
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
              message: "* Required field",
            },
          ]}
          name={LoginSignupFormType.lastName}
          className="inputCss formItemMarginBotton"
        >
          <Input
            id="lastName"
            type="text"
            onInput={onNameChange}
            placeholder={t("Lastname")}
            allowClear={true}
          />
        </Form.Item>

        <Form.Item
          hasFeedback={true}
          rules={[
            {
              required: true,
              message: "* Required field",
            },
            {
              validator: vuaIdValidator,
            },
          ]}
          name={LoginSignupFormType.vuaId}
          className="inputCss formItemMarginBotton"
        >
          <Input
            id="vuaId"
            type="text"
            onInput={onVUANameChange}
            placeholder={t("Enter pbfin-aa handle")}
            suffix={vuaIdSuffix.value}
            allowClear={true}
          />
        </Form.Item>

        <PinInputComponent
          id="pin"
          label={t("Enter PIN")}
          className="inputCss"
        />
      </div>
    </>
  );
};

export default UserInformation;
